import axios from 'axios'
import Vue from 'vue'
import { getLegalSign } from '@/utils/index'
const instance = axios.create({
  baseURL: '/apis', // 设置请求的基本路径
  timeout: 10000 // 设置超时时间
})

// 2. 添加请求拦截器：1. 批量修改请求参数， 2. 批量添加请求参数
instance.interceptors.request.use(config => {
  if (config.url.includes('/coursera/common/user/send/msg')) {
    config.headers['legalSign'] = getLegalSign()
  }
  return config
})
//过滤
const fliters = function (res) {
  if (res.code == 500) {
    Vue.prototype.$toast.center(res.msg)
  }
  if (res.code == 504) {
    Vue.prototype.$toast.center('网络小波动，请稍后重试')
  }
}
// 3. 设置响应拦截器
instance.interceptors.response.use(
  response => {
    fliters(response.data)
    if (response.data.code != 200) {
      return Promise.reject(response.data)
    }
    return response.data
  },
  error => {
    try {
      fliters(error.response.data)
    } catch (e) {
      fliters({ code: 504 })
    }

    return Promise.reject(error)
  }
)

export default instance
